import React from 'react'
import PropTypes from 'prop-types'
import MuiModal from '@mui/material/Modal'
import Box from '@mui/material/Box'
import CloseIcon from '@mui/icons-material/Close'
import IconButton from '@mui/material/IconButton'
import styles from './modal.module.scss'

export function Modal(props) {
  return (
    <div className={styles['modal-wrapper']}>
      <MuiModal
        open={props.isOpen}
        onClose={props.closeModalFunc}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '40%',
            minHeight: '20%',
            bgcolor: 'white',
            // border: '1px solid #000',
            borderRadius: '7px',
            boxShadow: 2,
            p: 2,
            textAlign: 'left',
            display: 'flex',
          }}
        >
          {props.children}
          {props.closeButton
            && (
            <IconButton
              sx={{
                position: 'absolute', top: '3%', right: '0.5%', padding: '0', display: 'block'
              }}
              onClick={props.closeModalFunc}
            >
              <CloseIcon className={styles.closeIcon} />
            </IconButton>
            )}
        </Box>
      </MuiModal>
    </div>
  )
}

Modal.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  closeButton: PropTypes.bool,
  isOpen: PropTypes.bool.isRequired,
  closeModalFunc: PropTypes.func.isRequired,
}

Modal.defaultProps = {
  closeButton: false,
}
